import { Col, Modal, Radio, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiAddTestInformationStatus } from '../../apis/testInformation';

const ModalValidation = ({ actionRef, reset }) => {
  const { t } = useTranslation();
  const [isMounted, setIsMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const [records, setRecord] = useState([]);
  const [value, setValue] = useState("REQUEST_REVIEW");

  const handleCancel = () => {
    handleClose();
  };
  const handleClose = () => {
    setVisible(false);
  };
  const handleOpen = (records) => {
    setValue("REQUEST_REVIEW")
    setRecord(records)
    setVisible(true);
  };

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
    }
    const userAction = {
      open: handleOpen,
      close: handleClose,
    }

    if (actionRef && typeof actionRef === "function") {
      actionRef(userAction)
    }
    if (actionRef && typeof actionRef !== "function") {
      actionRef.current = userAction
    }

    return () => {
      setIsMounted(false);
    }
    // eslint-disable-next-line
  }, [])

  const handleSubmit = async () => {
    await apiAddTestInformationStatus({
      objectList: records,
      testStatus: value,

    })
    handleClose();
    reset && reset();
  }

  const onChange = (e) => {
    setValue(e.target.value)
  }

  return (
    <Modal
      centered={true}
      title={"Yêu cầu phê duyệt"}
      visible={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      // cancelButtonProps={{ style: { display: "none" } }}
      okText={t("BUTTON.save")}
      cancelText={"Huỷ"}
      okButtonProps={{ htmlType: "submit" }}
      width={1000}
      forceRender
    >
      <Row>
        <Col span={6}>Quy trình xác nhận</Col>
        <Col span={18}>
          <Radio.Group onChange={onChange} value={value}>
            <Radio value={"REQUEST_REVIEW"}>Đánh giá</Radio>
            <Radio value={"REQUEST_APPROVED"}>Phê duyệt</Radio>
          </Radio.Group>
        </Col>
      </Row>
    </Modal>
  )
}

export default ModalValidation;